import React from 'react'
import cx from 'classnames'
import './Typography.scss'

const Heading1 = ({ children, white, center, className, left, style, purple, black }) => (
    <h1 style={style}
        className={cx(
            'heading1',
            className,
            white && 'heading-white',
            center && 'text-center',
            left && 'text-left',
            purple && 'heading-purple',
            black && 'heading-black'
        )}>
        {children}
    </h1>
)

export default Heading1



// WEBPACK FOOTER //
// /usr/src/site-blog/src/components/site/typography/Heading1.jsx